import { panelTypes } from '../../common/panel/constants'
import { Director } from './director'
import { Industry } from './industry'
import { Management } from './management'
import { Overview } from './overview/index'

export const HIGHLIGHT_KEYS = {
  YEARS_OF_OPERATION: 'age',
  NUMBER_OF_EMPLOYEES: 'numberOfEmployee',
  LISTING_STATUS: 'listingStatusName',
  CHARTER_CAPITAL: 'charterCapital',
}

export const PANEL_ID = {
  OVERVIEW: 'OVERVIEW',
  INDUSTRY: 'INDUSTRY',
  DIRECTOR: 'DIRECTOR',
  MANAGEMENT: 'MANAGEMENT',
}

export const PANEL_DATA = [
  {
    id: PANEL_ID.OVERVIEW,
    type: panelTypes.FULL_SIZE,
    label: 'companyProfile.COMPANY_OVERVIEW',
    component: Overview,
  },
  {
    id: PANEL_ID.INDUSTRY,
    type: panelTypes.FULL_SIZE,
    label: 'companyProfile.INDUSTRY_CLASSIFICATION',
    component: Industry,
  },
  {
    id: PANEL_ID.DIRECTOR,
    type: panelTypes.HALF_SIZE,
    label: 'companyProfile.BOARD_OF_DIRECTOR',
    component: Director,
  },
  {
    id: PANEL_ID.MANAGEMENT,
    type: panelTypes.HALF_SIZE,
    label: 'companyProfile.BOARD_OF_MANAGEMENT',
    component: Management,
  },
]

export const OVERVIEW_KEYS = {
  VIETNAMESE_NAME: 'organizationName',
  INTERNATIONAL_NAME: 'en_OrganizationName',
  SHORT_NAME: 'organizationShortName',
  TAX_CODE: 'taxCode',
  TICKER_SYMBOL: 'ticker',
  ENTERPRISE_STATUS: 'activeStatusName',
  LISTING_STATUS: 'listingStatusName',
  ACCOUNTING_PERIOD: 'accountingPeriod',
  LEGAL_FORM: 'legalFormName',
  COMPANY_TYPE: 'companyType',
  DATE_OF_REGISTRATION: 'registerDate',
  YEARS_OF_OPERATION: 'age',
  NUMBER_OF_EMPLOYEES: 'numberOfEmployee',
  LEGAL_REPRESENTATIVE: 'legalRepresentative',
  PHONE: 'telephone',
  FAX: 'fax',
  WEBSITE: 'website',
  EMAIL: 'email',
  ADDRESS: 'address',
  MAP: 'addressForMap',
}

export const OVERVIEW_KEY_COUNT_PER_BOX = [5, 5, 4, 5, 1]

export const INDUSTRY_TYPE = {
  VSIC: 'VSIC',
  ICB: 'ICB',
}

export const BOARD_COL_IDS = {
  STT: 'stt',
  NAME: 'fullname',
  POSITION: 'positionName',
  SHAREHOLDING: 'percentage',
}
